/*************************************************************************
*
*  Copyright 2022 Adobe
*  All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

// eslint-disable-next-line import/prefer-default-export
export const MAXIMUM_ACTIVE_AJS_INSTANCE_LIMIT = 5;

/**
 * Enum to indicate state of AcrobatJSInstance.
 */
export const acrobatjsState = Object.freeze({
    CACHED: 0,
    ACTIVE: 1,
    IDLE: 2,
});

export const EDIT_APIS = new Set([]);

export const ORGANIZE_APIS = new Set([
    "organizeWillBegin",
    "insertPages",
    "insertBlankPage",
    "deletePages",
    "reorderPages",
    "rotatePages",
    "extractPages",
    "organizeDidEnd",
]);

export const ADDITIONAL_APIS = new Set([
    "isScannedDocument",
    "detectLanguage",
    "getAnnots",
    "extractPageText",
    "detectSignFields",
]);

export const ERRORS = Object.freeze({
    INVALID_INTENT: "Intent Is Invalid",
    FETCH_TOKEN_FAILURE: "Fetch Token Failure",
    UNKNOWN_ERROR: "Unknown Error",
});

export const DOCUMENT_ASSEMBLY_PERM = 10;
